//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from "d3";

export default {
  name: "VerticalBarsChart",
  props: {
    id: String,
    disableKey: Boolean,
    chartWidth: Number,
    chartHeight: Number,
    mainColor: String,
    secondaryColor: String,
    mainGraphKey: Number,
    secondaryGraphKey: Number,
    valueLabel: String,
    unitLabel: String,
    retailer: String,
    data: Object,
    margin: Object,
    isLoading: Boolean,
    lineValueMarginTop: {
      type: Number,
      default: 0,
    },
    lineValueMarginBottom: {
      type: Number,
      default: 0,
    },
  },
  mounted: function () {
    this.renderChart();
  },
  computed: {
    mainData: function () {
      return this.data.mainData;
    },
    secondaryData: function () {
      return this.data.secondaryData;
    },
    lineData: function () {
      return this.data.lineData;
    },
  },
  watch: {
    data: {
      deep: true,
      handler: function () {
        this.renderChart();
      },
    },
    chartWidth: {
      immediate: true,
      handler: function () {
        this.renderChart();
      },
    },
    chartHeight: {
      immediate: true,
      handler: function () {
        this.renderChart();
      },
    },
  },
  methods: {
    // FIXME
    // Make the chart responsive somehow.
    // Delete the casts.
    renderChart: function () {
      d3.selectAll(`#${this.id} > *`).remove();
      var width = Number(this.chartWidth);
      var height = Number(this.chartHeight);

      var margin = {
        top: Number(this.margin.top),
        right: Number(this.margin.right),
        bottom: Number(this.margin.bottom),
        left: Number(this.margin.left),
      };

      var verticalGraphTooltip = d3
        .select(`#${this.id}-parent`)
        .append("div")
        .attr("class", "tool-tip");

      var x = d3
        .scaleBand()
        .domain(
          d3.range(
            d3.max([
              this.mainData.length,
              this.secondaryData ? this.secondaryData.length : 0,
            ])
          )
        )
        .range([margin.left, width - margin.right])
        .padding(0.1);

      // FIXME
      // Get the values from both data types when needed.
      var y = d3
        .scaleLinear()
        .domain([
          0,
          d3.max(
            this.mainData.concat(this.secondaryData ? this.secondaryData : []),
            (d) => d.value
          ) * 1.1,
        ])
        .nice()
        .range([height - margin.bottom, margin.top]);

      var per = d3
        .scaleLinear()
        .domain([
          d3.min(this.lineData, (d) => d[1] - this.lineValueMarginBottom),
          d3.max(this.lineData, (d) => d[1] + this.lineValueMarginTop),
        ])
        .nice()
        .range([height - margin.bottom, margin.top]);

      function wrap(text, width) {
        text.each(function () {
          var text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [],
            lineNumber = 0,
            lineHeight = 1.1, // ems
            y = text.attr("y"),
            dy = parseFloat(text.attr("dy")),
            tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
          // eslint-disable-next-line no-cond-assign
          while (word = words.pop()) {
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
            }
          }
        });
      }

      var xAxis = (g) =>
        g
          .attr("transform", `translate(0,${height - margin.bottom})`)
          .call(
            d3
              .axisBottom(x)
              .tickFormat((i) => this.mainData[i].label)
              .tickSizeOuter(0)
          )
          .call((g) =>
            g
              .append("text")
              .attr("transform", "rotate(-90)")
              .attr("x", width - margin.right)
              .attr("y", 0)
              .attr("fill", "currentColor")
              .attr("text-anchor", "start")
          )

      var yAxis = (g) =>
        g
          .attr("transform", `translate(${margin.left},0)`)
          .call(d3.axisLeft(y).ticks(10, "s"))
          .call((g) =>
            g
              .append("text")
              .attr("x", 0)
              .attr("y", 10)
              .attr("fill", "currentColor")
              .attr("text-anchor", "start")
          );

      var yGrid = d3
        .axisLeft(y)
        .ticks(10)
        .tickSize(-this.chartWidth)
        .tickFormat("");

      var perAxis = (g) =>
        g
          .attr("transform", `translate(${width - margin.right},0)`)
          .call(
            d3.axisRight(per).tickFormat(function (d) {
              return parseInt(d, 10) + "%";
            })
          )
          .call((g) =>
            g
              .append("text")
              .attr("x", 0)
              .attr("y", 10)
              .attr("fill", "currentColor")
              .attr("text-anchor", "start")
          );

      var svg = d3
        .select(this.$refs.verticalBarsChart)
        .attr("width", width)
        .attr("height", height);

      svg.append("g").attr("class", "grid").call(yGrid);

      // var chart =
      //Main Rectangle
      svg
        .append("g")
        .attr("fill", this.mainColor)
        .attr("class", "graph-rectangle")
        .selectAll("rect")
        .data(this.mainData)
        .join("rect")
        .on("click", (_e, event) => {
          this.$emit("selected-data", event);
        })
        .attr("x", (d, i) => x(i))
        .transition()
        .attr("y", (d) => y(d.value))
        .attr("height", (d) => y(0) - y(d.value))
        .attr("width", this.secondaryData ? x.bandwidth() / 2 : x.bandwidth())
        .duration(0);

      //Secondary Rectangle
      if (this.secondaryData) {
        svg
          .append("g")
          .attr("fill", this.secondaryColor)
          .attr("class", "graph-rectangle")
          .selectAll("rect")
          .data(this.secondaryData)
          .join("rect")
          .on("click", (_e, event) => {
            this.$emit("selected-data", event);
          })
          .attr("x", (d, i) => x(i) + x.bandwidth() / 2)
          .transition()
          .attr("y", (d) => y(d.value))
          .attr("height", (d) => y(0) - y(d.value))
          .attr("width", x.bandwidth() / 2)
          .duration(0);
      }

      if (this.lineData) {
        var line = d3
          .line()
          // .curve(d3.curveBasis)
          // .defined((d) => (d[1]))
          .x((d) => x(d[0]) + x.bandwidth() / 2)
          .y((d) => per(d[1]));

        svg
          .append("path")
          .datum(this.lineData)
          .attr("fill", "none")
          .attr("stroke", "#6d9c64")
          .attr("stroke-width", 2)
          .style("stroke-dasharray", "7, 10")
          .attr("stroke-linejoin", "round")
          .attr("d", line);

        svg
          .selectAll("myCircles")
          .data(this.lineData)
          .enter()
          .append("circle")
          .attr("fill", "#229E6A")
          .attr("stroke", "none")
          .attr("cx", (d) => x(d[0]) + x.bandwidth() / 2)
          .attr("cy", (d) => per(d[1]))
          .attr("r", 5);
      }

      svg.append("g").call(xAxis).selectAll(".tick text").call(wrap, x.bandwidth());

      svg.append("g").call(yAxis);

      svg.append("g").call(perAxis);

      //Graph Keys
      if (!this.disableKey) {
        if (this.mainGraphKey) {
          svg
            .append("circle")
            .attr("cx", 40)
            .attr("cy", 9)
            .attr("r", 6)
            .style("fill", this.mainColor);
          svg
            .append("text")
            .attr("class", "graph-key")
            .attr("x", 55)
            .attr("y", 10)
            .text(this.mainGraphKey)
            .style("font-size", "15px")
            .attr("alignment-baseline", "middle");
        }
        if (this.secondaryGraphKey) {
          svg
            .append("circle")
            .attr("cx", 110)
            .attr("cy", 9)
            .attr("r", 6)
            .style("fill", this.secondaryColor);
          svg
            .append("text")
            .attr("class", "graph-key")
            .attr("x", 125)
            .attr("y", 10)
            .text(this.secondaryGraphKey)
            .style("font-size", "15px")
            .attr("alignment-baseline", "middle");
        }
        if (this.lineData.length) {
          svg
            .append("circle")
            .attr("cx", 180)
            .attr("cy", 9)
            .attr("r", 6)
            .style("fill", "#229E6A");
          svg
            .append("text")
            .attr("class", "graph-key")
            .attr("x", 195)
            .attr("y", 10)
            .text("Variação")
            .style("font-size", "15px")
            .attr("alignment-baseline", "middle");
        }
      }
      svg
        .selectAll("rect")
        .on("mousemove", (e, data) => {
          verticalGraphTooltip.style("left", e.clientX + 10 + "px");
          verticalGraphTooltip.style("top", e.clientY - 20 + "px");
          verticalGraphTooltip.style("opacity", "1");
          verticalGraphTooltip.html(
            "<div>" + this.valueLabel + ": " + (data
              ? d3.format(".3s")(data.value)
              : 0) + " " + this.unitLabel + "</div>"
          );
        })
        .on("mouseout", function () {
          verticalGraphTooltip.style("opacity", "0");
        });

      svg
        .selectAll("circle")
        .on("mousemove", function (e, data) {
          verticalGraphTooltip.style("left", e.clientX + 10 + "px");
          verticalGraphTooltip.style("top", e.clientY - 20 + "px");
          verticalGraphTooltip.style("opacity", "1");
          verticalGraphTooltip.html(
            "<div>Variação: " +
            d3.format(".2s")(data[1] ? data[1] : 0) +
            "%</div>"
          );
        })
        .on("mouseout", function () {
          verticalGraphTooltip.style("opacity", "0");
        });
    },
  },
};
